export const ajax = async (path) => {
    const response = await fetch(path);
    const html = await response.text();
    const fragment = new Range().createContextualFragment(html);

    Site.attachBehaviors(fragment);

    return fragment;
};
